import { Box, CircularProgress, IconButton } from '@mui/material'
import { useContext } from 'react'
import { MdRefresh } from 'react-icons/md'

import { EntityListContext } from '../../../Contexts'
import EntityFilterBox from './FilterSelect'
import EntitySortBox from './SortSelect'

const SelectBox: React.FC = () => {
  const { sortedEntityList, update } = useContext(EntityListContext)

  const onRefresh = () => {
    update?.()
  }
  return (
    <Box alignItems="center" display="flex" flexDirection="row" justifyContent="flex-start" marginX={0.5}>
      <Box marginX={0.5} style={{ zoom: 0.75 }}>
        <EntityFilterBox />
      </Box>
      <Box marginX={0.5} style={{ zoom: 0.75 }}>
        <EntitySortBox />
      </Box>
      <Box sx={{ display: { md: 'none' } }} flexGrow={1} />
      <Box alignItems="center" display="flex" justifyContent="center">
        <IconButton onClick={onRefresh}>{sortedEntityList ? <MdRefresh /> : <CircularProgress size={16} />}</IconButton>
      </Box>
    </Box>
  )
}

export default SelectBox
